import yo from "../assets/img/yo.jpg";

export const profile = {
  name: "GERMAN APAZA",
  image: yo,
};

export const contact = {
  whatsapp: "+51 925 710 617",
  github: "https://github.com/ANG95",
  email: "german.apaza.n@gmail.com",
};

export const skills = [
  "ReactJS",
  "React Native (CLI & Expo)",
  "ElectronJS",
  "NodeJS (Express)",
  "Jetpack Compose",
  "MySQL",
  "GitHub (GitHub Actions)",
  "Kotlin",
  "Android",
  "PHP",
  "AWS",
  "Web Sockets",
  "GraphQL",
  "MongoDB",
  "WordPress",
];
